import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

type ButtonProps = {
  label: string;
  onClick: () => void;
};

type PopUpProps = {
  title: string;
  text?: string;
  smallText?: string;
  textComponent?: React.ReactNode;
  button?: ButtonProps;
  extraButton?: ButtonProps;
  onClose: () => void;
};

const PopUp: React.FC<PopUpProps> = ({
  title,
  text,
  smallText,
  textComponent,
  button,
  extraButton,
  onClose,
}) => {
  useEffect(() => {
    // Block scrolling when pop-up is open
    document.body.style.overflow = 'hidden';

    // Close pop-up if click outside of it
    const handleClickOutside = (event: MouseEvent) => {
      const popup = document.querySelector('.popup');
      if (popup && !popup.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="overlay">
      <div className="popup scale-95 opacity-0 animation-show max-h-[80vh] overflow-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-800">
            <FaTimes size={20} />
          </button>
        </div>

        {/* Main content */}
        {textComponent ? (
          <div className="text-gray-700 mb-4">{textComponent}</div> // Render the TSX component
        ) : (
          <p className="text-gray-700 mb-4">{text}</p> // Fallback to text if no component is provided
        )}
        {smallText && <p className="text-sm text-gray-500 mb-4">{smallText}</p>}

        {/* Buttons */}
        <div className="flex justify-end space-x-2">
          {extraButton && (
            <button
              onClick={extraButton.onClick}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              {extraButton.label}
            </button>
          )}
          <button
            onClick={button?.onClick || onClose}
            className={`px-4 py-2 rounded text-white ${
              extraButton ? 'bg-blue-500 hover:bg-blue-600' : 'bg-blue-500 hover:bg-blue-600 w-full'
            }`}
          >
            {button?.label ?? 'Закрыть'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
